import { useNavigate } from "react-router-dom";

export default function MentionsLegales() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen text-white relative">
      {/* Fixed global background */}
      <div className="fixed inset-0 -z-50">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20dark%20digital%20background%20dominated%20by%20deep%20black%20and%20rich%20dusty%20rose%20pink%20tones%2C%20soft%20blush%20pink%20glowing%20light%20orbs%20and%20delicate%20pink%20neon%20geometric%20curves%20floating%20in%20dark%20space%2C%20elegant%20web%20design%20wireframes%20and%20typography%20compositions%20in%20subtle%20rose%20pink%20hues%2C%20smooth%20pink%20gradient%20light%20rays%20emanating%20from%20corners%2C%20no%20yellow%2C%20no%20orange%2C%20no%20warm%20gold%20tones%2C%20only%20cool%20rose%20pink%20and%20black%2C%20sophisticated%20feminine%20digital%20art%20studio%20aesthetic%2C%20no%20people%2C%20no%20faces%2C%20cinematic%20depth%20with%20soft%20pink%20bokeh%2C%208K%20ultra%20detailed%20professional%20digital%20art&width=1920&height=1080&seq=manovahero5rose&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-[65%_center] md:object-center"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 py-32 md:py-40">
        <button
          onClick={goBack}
          className="flex items-center gap-2 text-sm text-white/50 hover:text-brand transition-colors mb-12"
        >
          <i className="ri-arrow-left-line"></i>
          Retour au site
        </button>

        <h1 className="text-3xl md:text-4xl font-display font-medium text-white mb-10">
          Mentions légales
        </h1>

        <div className="space-y-10 text-white/70 text-base leading-relaxed font-light">
          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Propriétaire du site
            </h2>
            <p>
              <strong className="text-white/90 font-medium">Manova Digital</strong>
              <br />
              Prénom Nom
              <br />
              Montreux, Suisse
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Contact
            </h2>
            <p>
              Email : contact@manova-digital.ch
              <br />
              Le site est hébergé par Readdy.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Propriété intellectuelle
            </h2>
            <p>
              Tous les contenus présents sur le site (textes, images, logos, vidéos) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Limitation de responsabilité
            </h2>
            <p>
              Les informations fournies sur ce site le sont à titre indicatif. Manova Digital ne peut garantir l'exactitude, la complétude ou l'actualité des informations diffusées. L'utilisateur est responsable de l'utilisation qu'il fait des informations disponibles sur le site.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-display font-medium text-white mb-3">
              Liens externes
            </h2>
            <p>
              Le site peut contenir des liens vers des sites tiers. Manova Digital n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}